import { CONTEXT_EVENTS } from '../../constants/events';


export const updateContext = (context = {}) => ({
	type: CONTEXT_EVENTS.UPDATE_CONTEXT,
	payload: context
});

export const updateApplyAfterCityChange = (city) => ({
    type: CONTEXT_EVENTS.UPDATE_CONTEXT,
    payload: { cityForLocality: city }
});

export const updateApplyAfterLocalityChange = (locality) => ({
  type: CONTEXT_EVENTS.UPDATE_CONTEXT,
  payload: { localityForLocality: locality }
});

export const toggleSearchPopupFilter = (value) => ({
  type: CONTEXT_EVENTS.SEARCH_POPUP_TOGGLE,
  payload: {value}
});

export const toggleLoader = (value) => ({
  type: CONTEXT_EVENTS.TOGGLE_LOADER,
  payload: { showLoader: value }
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/ContextActions/index.js